import React, { useState, useMemo, memo } from 'react';
import { useSelector } from 'react-redux';

import { Dropdown, Menu } from 'antd';

import { insightMenuAcions, insightModals, projectRole } from '@model';

const InsightMenu = ({
  isOpen,
  menuList: menuListInProps,
  hideMenu,
  editRow,
  toggleInsightMenu,
  showModal,
}) => {
  const role = useSelector(({ login }) => login.userInfo?.role);
  const projectPermission = useSelector(
    (state) => state.common.projectCompanyInfo?.currentUserPermission,
  );
  const isPwcReadOnly = projectPermission === projectRole['View-Only'];
  const actionHandler = (e) => {
    switch (e.key) {
      case insightMenuAcions.EDIT:
        editRow();
        break;

      case insightMenuAcions.ADDINSIGHT:
        showModal({
          type: insightModals.INSIGHT_FORM,
          isEdit: false,
        });
        break;

      case insightMenuAcions.VIEWINSIGHT:
        showModal({
          type: insightModals.INSIGHT_LIST,
        });
        break;

      default:
        break;
    }

    hideMenu(false);
  };

  const menuList = menuListInProps.filter(
    (menu) =>
      (role !== 'client' && !isPwcReadOnly) ||
      menu === insightMenuAcions.VIEWINSIGHT,
  );

  const menu = useMemo(
    () => (
      <Menu onClick={actionHandler}>
        {menuList.map((menuItem) => (
          <Menu.Item key={menuItem}>{menuItem}</Menu.Item>
        ))}
      </Menu>
    ),
    [menuList],
  );

  if (menuList.length === 0) {
    return null;
  }
  return (
    <Dropdown
      overlayClassName="insight-menu-dropdown"
      trigger={['click']}
      overlay={menu}
      onVisibleChange={toggleInsightMenu}
      visible={isOpen}
      placement="bottomRight"
    >
      <>
        <div
          className={`appkiticon icon-vertical-more-fill action-control ${
            isOpen ? 'action-control-isactive' : ''
          }`}
          onClick={toggleInsightMenu}
        />
      </>
    </Dropdown>
  );
};

const Action = ({
  list = [],
  showModal,
  index,
  activeIndex,
  openFunc,
  editRow,
  category,
  uuid,
}) => {
  const [menuStatus, setMenuStatus] = useState(false);
  const toggleInsightMenu = () => {
    setMenuStatus(!menuStatus);
    openFunc(index);
  };
  const hideMenu = () => {
    setMenuStatus(false);
    openFunc(undefined);
  };
  const openModal = (config) => {
    showModal({ ...config, category, uuid });
  };
  return (
    <div className="insightMenu">
      <InsightMenu
        toggleInsightMenu={toggleInsightMenu}
        isOpen={menuStatus && index === activeIndex && list.length > 0}
        menuList={list.filter((item) => item)}
        hideMenu={hideMenu}
        editRow={editRow}
        showModal={openModal}
      />
    </div>
  );
};
export default memo(Action);
